import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import { IUserRoleDialogProps } from '../../interfaces';



export const UserRoleDialog: React.SFC<IUserRoleDialogProps> = ({
    user,
    roles,
    onSubmitRole,
    ...props
}: IUserRoleDialogProps) => {


    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault();

        if (e.currentTarget.checkValidity()) {


            onSubmitRole(userRole);


            setOpen(false);
        } else {

        }

    }

    const onCancel = () => {
        setOpen(false);
    }

    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [userRole, setUserRole] = useState<string>(user?.role?.roleId);


    return (
        <span>
            <Button variant="outlined" onClick={() => setOpen(true)}>
                Change
            </Button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="xs"
            >
                <form
                    onSubmit={(e) => onSubmit(e)}
                    onInvalid={() => setErrorMessage("please check that all required fields have been populated")}
                >
                    <DialogTitle>
                        Select a role for {user.name}
                    </DialogTitle>
                    <DialogContent>
                        <Grid container >
                            <Grid item={true} xs={10} sx={{ p: 0.5 }}>
                                <FormControl fullWidth sx={{ mt: 1 }}>
                                    <InputLabel id="user-role-select-label">User Role</InputLabel>
                                    <Select
                                        labelId="user-role-select-label"
                                        id="user-role-select"
                                        value={userRole}
                                        label="User Role"
                                        onChange={(e) => setUserRole(e.target.value)}
                                    >
                                        {
                                            roles && roles.map(x => {
                                                return <MenuItem key={x?.roleId} value={x?.roleId}>{x?.name}</MenuItem>
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        {errorMessage &&
                            <DialogContentText color="error">
                                {errorMessage}
                            </DialogContentText>
                        }

                    </DialogContent>
                    <DialogActions>

                        <Button onClick={onCancel} color="warning">Cancel</Button>

                        <Button type="submit">Save</Button>

                    </DialogActions>

                </form>
            </Dialog>
        </span>
    );
}